import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
import { useTranslation, Trans } from "react-i18next";
import { flatOrI18n, roleTitle } from "../_helpers";

export default function RoleDialog(props) {
  const [roleId, setRole] = React.useState(0);
  const [confId, setConf] = React.useState(0);
  const [teamId, setTeam] = React.useState(0);
  const [count, setCount] = React.useState(0);

  const {
    handleClose,
    roles_list,
    conf_list,
    dialogOpen,
    old_confId,
    old_roleId,
	id,
    needPeople = false,
    team = [],
  } = props;

  const { t } = useTranslation();

  // Организатора в списке нет намеренно: роль назначается участнику команды,
  // а владельцу она не нужна — у него полные права по определению. Бэкенд такую
  // попытку отклоняет («This action is unauthorized»), и у нового организатора,
  // где в команде пока только он сам, единственный пункт списка был заведомо
  // нерабочим. Список приходит с withOrg=1, поэтому фильтруем здесь.
  const assignableTeam = (team || []).filter((item) => item.type !== "org");

  React.useEffect(() => {
    if (count == 0) {
      setConf(old_confId);
      setRole(old_roleId);
      setTeam(id);
    }
  });

  function selectRole(e) {
    setCount(count + 1);
    setRole(e);
  }

  function selectConf(e) {
    setCount(count + 1);
    setConf(e);
  }

  function selectTeam(e) {
    setCount(count + 1);
    setTeam(e);
  }

  function saveData() {
    console.log(roleId, confId);

    if (roleId > 0) {
      if (needPeople) {
        if (teamId > 0) handleClose({ roleId, confId, teamId });
      } else handleClose({ roleId, confId, teamId: 0 });

      setCount(0);
    }
  }

  function cancelData() {
    handleClose("");
    setCount(0);
  }

  return (
    <Dialog open={dialogOpen}>
      <DialogTitle>
        {old_confId === 0 ? t("add_role") : t("edit_role")}
      </DialogTitle>
      <form>
        <DialogContent>
          {needPeople && (
            <div style={{ paddingBottom: 10 }}>
              {assignableTeam.length > 0 ? (
                <select onChange={(e) => selectTeam(e.target.value)}>
                  <option value={0} selected={roleId == 0}>
                    {t("select_team_membe")}
                  </option>
                  {assignableTeam.map((item, index) => (
                    <option value={item.id} selected={teamId == item.id}>
                      {/* Плоское имя у участника часто не заполнено, и пункт
                          выглядел пустой строкой — выбирать было не из чего. */}
                      {flatOrI18n(item) || item.email}
                    </option>
                  ))}
                </select>
              ) : (
                <div>{t("no_team_members_yet")}</div>
              )}
            </div>
          )}
          <div style={{ paddingBottom: 10 }}>
            <select onChange={(e) => selectRole(e.target.value)}>
              <option value={0} selected={roleId == 0}>
              {t("select_role")}
              </option>
              {roles_list.map((item, index) => (
                <option value={item.id} selected={roleId == item.id}>
                  {roleTitle(item.name)}
                </option>
              ))}
            </select>
          </div>
          <span>{t("select_conf")}</span>
          <select onChange={(e) => selectConf(e.target.value)}>
            <option value={0} selected={confId == 0}>
              {t("without_event")}
            </option>
            {conf_list.map((item, index) => (
              <option value={item.id} selected={confId == item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </DialogContent>
        <DialogActions>
          <Button onClick={saveData}>{t("btn_save")}</Button>
          <Button onClick={cancelData}>{t("btn_cancel")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
